import { z } from 'zod';

export const getOtpSchema = z.object({
  phoneNumber: z
    .string()
    .min(10, 'validation.phoneInvalid')
    .regex(/^\d+$/, 'validation.phoneDigits'),
  capabilities: z.array(z.enum(['validator', 'inspector'])).optional(),
});

export type GetOtpFormValues = z.infer<typeof getOtpSchema>;
